<template>
  <a
    :href="href"
    target="_blank"
    rel="noopener noreferrer"
    :class="[
      'font-medium text-link underline-offset-2 transition-[text-underline-offset] duration-150 hover:underline-offset-4',
      variant === 'inline' ? 'underline' : 'hover:underline',
    ]"
  >
    <slot />
    <AppIcon
      name="arrow-up-right-from-square"
      size="sm"
      class="ml-1"
    />
  </a>
</template>

<script setup>
// External link. Opens in a new tab with a safe `rel`, and a trailing icon signals it leaves the
// app. Use AppInternalLink for in-app routes.
import AppIcon from './AppIcon.vue';

defineProps({
  /** The external URL. Always opens in a new tab with a safe `rel`. */
  href: {
    type: String,
    default: '#',
  },
  /**
   * `inline` for a link inside body text (underlined at rest, WCAG 1.4.1). `standalone` for a UI or
   * nav link (colour only, underline on hover).
   */
  variant: {
    type: String,
    default: 'standalone',
    validator: (value) => ['inline', 'standalone'].includes(value),
  },
});
</script>
